import React, { useEffect, useRef } from 'react';

export const PortfolioConfirmDialog = ({ rows, saving, onClose, onConfirm }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (rows && !ref.current.open) ref.current.showModal();
    if (!rows && ref.current.open) ref.current.close();
  }, [rows]);
  return <dialog ref={ref} className="portfolio-confirm-dialog" data-testid="portfolio-confirm-dialog" aria-labelledby="portfolio-confirm-title" onCancel={e => { e.preventDefault(); if (!saving) onClose(); }}>
    <h2 id="portfolio-confirm-title" className="text-lg font-semibold" data-testid="portfolio-confirm-title">¿Mantener cerrados estos activos?</h2>
    <p className="text-sm my-4" data-testid="portfolio-confirm-description">Se retirarán {rows?.length || 0} activos de CAMBIOS DE CARTERA. Se conservarán su estado Cerrado, su fase y su motivo de cierre.</p>
    <ul className="text-sm space-y-1 max-h-48 overflow-y-auto" data-testid="portfolio-confirm-selection">{(rows || []).map(a => <li key={a.id}>{a.codigo_npl || a.id}</li>)}</ul>
    <div className="flex flex-wrap justify-end gap-3 mt-6">
      <button type="button" className="btn-secondary" data-testid="portfolio-confirm-cancel" disabled={saving} onClick={onClose}>Cancelar</button>
      <button type="button" className="btn-primary" data-testid="portfolio-confirm-submit" disabled={saving} onClick={onConfirm}>{saving ? 'Confirmando…' : 'MANTENER CERRADO'}</button>
    </div>
  </dialog>;
};